/**
 * Sets `aria-hidden` on all elements on the body, except for the active node.
 **/
export function createAriaHider(
  containerNode,
  selector = "body > :not(script)"
) {
  const ariaHiddenAttribute = "aria-hidden";
  const rootNodes = Array.from(document.querySelectorAll(selector)).map(
    (node) => {
      if (node.contains(containerNode)) {
        return undefined;
      }
      const ariaHidden = node.getAttribute(ariaHiddenAttribute);
      if (ariaHidden === null || ariaHidden === "false") {
        node.setAttribute(ariaHiddenAttribute, "true");
      }

      return { node, ariaHidden };
    }
  );

  return () => {
    rootNodes.forEach((item) => {
      if (!item) return;
      if (item.ariaHidden === null) {
        item.node.removeAttribute(ariaHiddenAttribute);
      } else {
        item.node.setAttribute(ariaHiddenAttribute, item.ariaHidden);
      }
    });
  };
}
